import React from "react";
import { Button, Input, Modal, Select, Switch } from "antd"
import TextArea from "antd/lib/input/TextArea"
import { useAddUpdateAppVersionHook } from "../../hooks"
import "./appVersions.css"

export const AddUpdateAppVersionModal = ({
   selectedAppVersionData = {},
   isModalOpen = false,
   isEdit = false,
   handleSubmit = () => { },
   handleCloseModal = () => { }
}) => {
   const {
      isLoading,
      appVersionData,
      operatingSystemList,
      errorMessages,
      handleInputChange,
      handleSelectChange,
      handleSwitchChange,
      handleAppVersionSubmit
   } = useAddUpdateAppVersionHook({
      selectedAppVersionData,
      isModalOpen,
      isEdit,
      handleSubmit,
   })

   return (
      <Modal
         visible={isModalOpen}
         closable={true}
         title={isEdit ? "Edit App Version" : "Add App Version"}
         onCancel={() => handleCloseModal(false)}
         footer={[
            <Button
               className={'ml-2'}
               key="back"
               onClick={() => handleCloseModal(false)}
            >
               Cancel
            </Button>,
            <Button
               className={'ml-2'}
               key="submit"
               type="primary"
               loading={isLoading}
               onClick={() => handleAppVersionSubmit()}
            >
               Submit
            </Button>
         ]}
      >
         <div>

            <div className='mb-3 flex'>
               <div className='w-100'>
                  <div>Version Name</div>
                  <Input
                     name={"versionName"}
                     value={appVersionData.versionName || ""}
                     placeholder="Enter a version name"
                     onChange={handleInputChange}
                  />
                  {errorMessages.versionName && <span className='error-message'>{errorMessages.versionName}</span>}
               </div>
            </div>

            <div className='mb-3 flex'>
               <div className='w-100'>
                  <div>Version Code</div>
                  <Input
                     name={"versionCode"}
                     value={appVersionData.versionCode || ""}
                     placeholder="Enter a version name"
                     onChange={handleInputChange}
                  />
                  {errorMessages.versionCode && <span className='error-message'>{errorMessages.versionCode}</span>}
               </div>
            </div>

            <div className='mb-3'>
               <div>Device OS Type : </div>
               <Select
                  allowClear
                  style={{
                     width: '100%',
                  }}
                  placeholder="Please select category"
                  value={appVersionData.os || []}
                  onChange={(value) => handleSelectChange(value, "os")}
                  options={operatingSystemList || []}
               />
               {errorMessages.os && <span className='error-message'>{errorMessages.os}</span>}
            </div>

            <div className="flex mb-3">
               <Switch
                  checked={appVersionData.required === "true" || appVersionData.required === true || false}
                  onChange={(isChecked) => handleSwitchChange(isChecked, "required")}
               />
               <div className="mx-2">Do you want force update the app ?</div>
            </div>

            <div className='w-100'>
               <div>Description</div>
               <TextArea
                  name={"description"}
                  value={appVersionData.description || ""}
                  placeholder="Enter app version description"
                  rows={4}
                  onChange={handleInputChange}
               />
               {errorMessages.description && <span className='error-message'>{errorMessages.description}</span>}
            </div>

         </div>
      </Modal >
   )
}